import { SuccessReturnBody, getSuccessReturnBody } from '../general';
import { Source } from '../../types/fromDb/Sources/source'

export interface SourcePatchURIParams {
  id: number;
}

export type SourcePatchRequest = Omit<Source, 'id' | 'name'>;

export interface SourcePatchBody {
  status: 'success' | 'error';
}

export function patchSourceReturnBody(body: SourcePatchBody): SuccessReturnBody {
  return getSuccessReturnBody(body)
}
